import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Storage} from '@ionic/storage';
import {environment} from '../environments/environment';
import { TextboxQuestion } from 'src/app/modules/forms/common/question-textbox';
import { DropdownQuestion } from 'src/app/modules/forms/common/question-dropdown';
import { QuestionBase } from 'src/app/modules/forms/common/question-base';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WordPressService {

    _headers: HttpHeaders;
    vimeochannelheader: HttpHeaders;

    constructor(private http: HttpClient, private storage: Storage) {
        this._headers = new HttpHeaders();
        this._headers = this._headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');

        this.vimeochannelheader = new HttpHeaders();
        this.vimeochannelheader = this.vimeochannelheader.append('Authorization', 'Bearer 691b7c3ec98036571b366cc6c8d5b037');
        this.vimeochannelheader = this.vimeochannelheader.append('Content-Type', 'application/json');
    }

    getContent(data) {
      let api = environment.api_end_point + '/Content/content';
      // let api = "https://s3729.churchbase.site/feed/?post_type=wpfc_sermon&full=1";
      // -> let api = 'https://s2818.churchbase.io/feed/?post_type=wpfc_sermon&full=1';
      return this.http.post(api, data);
  }

  // TODO: get from a remote source of question metadata
  getQuestions(data) {

    const questions: QuestionBase<string>[] = [

      new DropdownQuestion({
        key: 'brave',
        label: 'Bravery Rating',
        options: [
          {key: 'solid',  value: 'Solid'},
          {key: 'great',  value: 'Great'},
          {key: 'good',   value: 'Good'},
          {key: 'unproven', value: 'Unproven'}
        ],
        order: 3
      }),

      new TextboxQuestion({
        key: 'firstName',
        label: 'First name',
        value: 'Bombasto',
        required: true,
        order: 1
      }),

      new TextboxQuestion({
        key: 'emailAddress',
        label: 'Email',
        type: 'email',
        order: 4
      }),
      new TextboxQuestion({
        key: 'image',
        label: 'Image',
        type: 'file',
        order: 2
      })
    ];

    let api = environment.api_end_point + '/content/formsData';
    return this.http.post(api, data)

    // return of(questions.sort((a, b) => a.order - b.order));
  }

  saveForm(data) {
    let api = environment.api_end_point + '/content/saveForm';
    return this.http.post(api, data)
  }

  saveFiles(data){
    let file_headers: HttpHeaders;
    file_headers = new HttpHeaders();
    file_headers = file_headers.append('Content-Type', 'multipart/form-data; boundary=----WebKitFormBoundaryuL67FWkv1CA');
    let api = environment.api_end_point + '/contentcms/uploadFile';
    return this.http.post(api, data, {headers: file_headers});
  }


}
